import React from "react";
import ReactDOM from "react-dom/client";

// No CSS imports - all styles are in the static HTML files

function App() {
  return null;
}

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}
